import React from "react";
import {observer} from "mobx-react-lite";
import {Modal, ModalBody, ModalFooter} from "reactstrap";
import ButtonIcon from "../../atoms/button/buttonIcon";
import {useTranslation} from "react-i18next";
import "./preReleaseConfirmationModal.sass";
import ModalDetailHeader from "../../molecules/modalDetailHeader/modalDetailHeader";
import {useStores} from "../../../stores/useStores";
import parse from "html-react-parser";
import Flex from "../../atoms/common/flex";

export interface IPreReleaseConfirmationModalModalProps {
  isOpen: boolean;
  toggle: () => void;
  onPublishBtnClicked: () => void;
  isSaving?: boolean;
  preReleaseDate?: string;
}

const PreReleaseConfirmationModal: React.FC<
  IPreReleaseConfirmationModalModalProps
> = ({isOpen, toggle, onPublishBtnClicked, isSaving, preReleaseDate}) => {
  const {t} = useTranslation(["translation", "event"]);
  const {
    uiStore: {modalStore}
  } = useStores();

  const message = t("translation:messages.confirmPrerelease", {
    preReleaseDate: preReleaseDate
  });
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      modalClassName="pre-release-modal"
      centered
    >
      <ModalDetailHeader isLoading={false} toggle={toggle}>
        <div className="header-container">
          <div className="header-column column-dynamic">
            {t("translation:titles.confirmPreRelease")}
          </div>
        </div>
      </ModalDetailHeader>
      <ModalBody>
        <div className="pre-release-body">{parse(message)}</div>
      </ModalBody>
      <ModalFooter
        tag={Flex}
        justify={modalStore.footerButtonAlignment}
        className={"event-publish-modal-footer"}
      >
        <div className="event-publish-modal-buttons">
          <div className="dont-publish-button">
            <ButtonIcon type="secondary" onClick={toggle}>
              {t("translation:actions.dontPublish")}
            </ButtonIcon>
          </div>
        </div>
        <ButtonIcon
          type={"primary"}
          onClick={() => onPublishBtnClicked()}
          isDisabled={isSaving}
        >
          {t("translation:confirmations.yesPublish")}
        </ButtonIcon>
      </ModalFooter>
    </Modal>
  );
};

export default observer(PreReleaseConfirmationModal);
